import _classCallCheck from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _possibleConstructorReturn from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";

/**
 * @file Created on Mon Nov 25 2019
 *
 * @///<reference path="packages/common-dp/src/core/transfer/common/model/TransferDataTypeLog.ts"/>
 *
 * @author JMe
 * @author Tomáš Leity
 * @author Vojtěch Smolař
 */
import { List } from 'immutable';
import { DomainObject } from '@logio/common-be-fe';
/**
 * Details about transfer of single data type.
 */

export var DPTransferDataTypeLog =
/*#__PURE__*/
function (_DomainObject) {
  _inherits(DPTransferDataTypeLog, _DomainObject);

  /**
   * @param name the data type name
   * @param requestId request id returned from IDB
   * @param started the start of processing data type
   * @param finished the end date of processing data type (regardless of success or error)
   * @param processors the list of processors that were being ran (regardless of success or error)
   * @param status the status of processing
   * @param transferMode
   */
  function DPTransferDataTypeLog(name, requestId, started, finished) {
    var _this;

    var processors = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : List();
    var status = arguments.length > 5 ? arguments[5] : undefined;
    var transferMode = arguments.length > 6 ? arguments[6] : undefined;

    _classCallCheck(this, DPTransferDataTypeLog);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(DPTransferDataTypeLog).call(this));
    _this.name = name;
    _this.requestId = requestId;
    _this.started = started;
    _this.finished = finished;
    _this.processors = processors;
    _this.status = status;
    _this.transferMode = transferMode;
    return _this;
  }

  return DPTransferDataTypeLog;
}(DomainObject);